import * as tslib_1 from "tslib";
import { CustomEvent } from './custom-event';
import { LinearScale, TimeScale } from './scale';
var KinematicScaleEvent = (function (_super) {
    tslib_1.__extends(KinematicScaleEvent, _super);
    function KinematicScaleEvent(type, init) {
        var _this = _super.call(this, type, init) || this;
        _this.kinematicScale = init.kinematicScale;
        _this.kinematic = init.kinematic;
        _this.ruler = init.ruler;
        _this.scale = init.scale;
        return _this;
    }
    return KinematicScaleEvent;
}(CustomEvent));
export { KinematicScaleEvent };
var KinematicScale = (function () {
    function KinematicScale() {
        this._kinematic = null;
        this._ruler = null;
        this._scale = null;
        this._xMin = null;
        this._xMax = null;
        this._zMin = null;
        this._zMax = null;
        this._points = [];
        this.onKinematicStart = this.onKinematicStart.bind(this);
        this.onKinematicUpdate = this.onKinematicUpdate.bind(this);
        this.onKinematicEnd = this.onKinematicEnd.bind(this);
    }
    KinematicScale.prototype.kinematic = function (kinematic) {
        if (kinematic === undefined) {
            return this._kinematic;
        }
        else {
            if (this._kinematic) {
                this.detach(this._kinematic);
            }
            this._kinematic = kinematic;
            if (this._kinematic) {
                this.attach(this._kinematic);
            }
            return this;
        }
    };
    KinematicScale.prototype.hysteresis = function (h) {
        if (h === undefined) {
            return this._kinematic.hysteresis();
        }
        else {
            this._kinematic.hysteresis(h);
            return this;
        }
    };
    KinematicScale.prototype.acceleration = function (a) {
        if (a === undefined) {
            return this._kinematic.acceleration();
        }
        else {
            this._kinematic.acceleration(a);
            return this;
        }
    };
    KinematicScale.prototype.velocityMax = function (vMax) {
        if (vMax === undefined) {
            return this._kinematic.velocityMax();
        }
        else {
            this._kinematic.velocityMax(vMax);
            return this;
        }
    };
    KinematicScale.prototype.distanceMin = function (dMin) {
        if (dMin === undefined) {
            return this._kinematic.distanceMin();
        }
        else {
            this._kinematic.distanceMin(dMin);
            return this;
        }
    };
    KinematicScale.prototype.wheel = function (wheel) {
        if (wheel === undefined) {
            return this._kinematic.wheel();
        }
        else {
            this._kinematic.wheel(wheel);
            return this;
        }
    };
    KinematicScale.prototype.ruler = function (ruler) {
        if (ruler === undefined) {
            return this._ruler;
        }
        else {
            this._ruler = ruler;
            return this;
        }
    };
    KinematicScale.prototype.scale = function (scale) {
        if (scale === undefined) {
            return this._scale;
        }
        else {
            var oldScale = this._scale;
            this._scale = scale;
            if (oldScale === null) {
                this.zoomBounds(true);
            }
            return this;
        }
    };
    KinematicScale.prototype.domainMin = function (_xMin) {
        if (_xMin === undefined) {
            return this._xMin;
        }
        else {
            this._xMin = _xMin;
            return this;
        }
    };
    KinematicScale.prototype.domainMax = function (_xMax) {
        if (_xMax === undefined) {
            return this._xMax;
        }
        else {
            this._xMax = _xMax;
            return this;
        }
    };
    KinematicScale.prototype.domainBounds = function (_xMin, _xMax) {
        if (_xMin === undefined) {
            return [this._xMin, this._xMax];
        }
        else if (_xMax === undefined) {
            _xMin = _xMin;
            this._xMin = _xMin[0];
            this._xMax = _xMin[1];
            return this;
        }
        else {
            this._xMin = _xMin;
            this._xMax = _xMax;
            return this;
        }
    };
    KinematicScale.prototype.zoomMin = function (_zMin) {
        if (_zMin === undefined) {
            return this._zMin;
        }
        else {
            this._zMin = _zMin;
            return this;
        }
    };
    KinematicScale.prototype.zoomMax = function (_zMax) {
        if (_zMax === undefined) {
            return this._zMax;
        }
        else {
            this._zMax = _zMax;
            return this;
        }
    };
    KinematicScale.prototype.zoomBounds = function (_zMin, _zMax) {
        if (_zMin === undefined) {
            return [this._zMin, this._zMax];
        }
        else if (_zMax === undefined) {
            if (typeof _zMin === 'boolean') {
                if (this._scale instanceof LinearScale) {
                    this._zMin = 1000000;
                    this._zMax = 0.001;
                }
                else if (this._scale instanceof TimeScale) {
                    this._zMin = 86400000;
                    this._zMax = 1;
                }
            }
            else {
                _zMin = _zMin;
                this._zMin = _zMin[0];
                this._zMax = _zMin[1];
            }
            return this;
        }
        else {
            this._zMin = _zMin;
            this._zMax = _zMax;
            return this;
        }
    };
    KinematicScale.prototype.attach = function (kinematic) {
        var surface = this._kinematic && this._kinematic.surface();
        if (surface) {
            surface.addEventListener('kinematicstart', this.onKinematicStart);
            surface.addEventListener('kinematicupdate', this.onKinematicUpdate);
            surface.addEventListener('kinematicend', this.onKinematicEnd);
        }
    };
    KinematicScale.prototype.detach = function (kinematic) {
        var surface = this._kinematic && this._kinematic.surface();
        if (surface) {
            surface.removeEventListener('kinematicstart', this.onKinematicStart);
            surface.removeEventListener('kinematicupdate', this.onKinematicUpdate);
            surface.removeEventListener('kinematicend', this.onKinematicEnd);
        }
    };
    KinematicScale.prototype.createPoint = function (kinematicPoint) {
        var coords = this.coords(kinematicPoint.cx, kinematicPoint.cy);
        return {
            identifier: kinematicPoint.identifier,
            domainCoord: coords.domainCoord,
            rangeCoord: coords.rangeCoord,
        };
    };
    KinematicScale.prototype.updatePoint = function (kinematicPoint, scalePoint) {
        scalePoint.rangeCoord = this.rangeCoord(kinematicPoint.cx, kinematicPoint.cy);
    };
    KinematicScale.prototype.updatePoints = function (kinematicPoints) {
        var scalePoints = this._points;
        outer: for (var i = 0; i < kinematicPoints.length; i += 1) {
            var kinematicPoint = kinematicPoints[i];
            for (var j_1 = 0; j_1 < scalePoints.length; j_1 += 1) {
                var scalePoint_1 = scalePoints[j_1];
                if (kinematicPoint.identifier == scalePoint_1.identifier) {
                    this.updatePoint(kinematicPoint, scalePoint_1);
                    continue outer;
                }
            }
            var scalePoint = this.createPoint(kinematicPoint);
            scalePoints.push(scalePoint);
        }
        var j = 0;
        outer: while (j < scalePoints.length) {
            var scalePoint = scalePoints[j];
            for (var i = 0; i < kinematicPoints.length; i += 1) {
                var kinematicPoint = kinematicPoints[i];
                if (scalePoint.identifier == kinematicPoint.identifier) {
                    j += 1;
                    continue outer;
                }
            }
            scalePoints.splice(j, 1);
        }
    };
    KinematicScale.prototype.clampScale = function () {
        var _xMin = this._xMin !== null ? this._xMin : undefined;
        var _xMax = this._xMax !== null ? this._xMax : undefined;
        var _zMin = this._zMin !== null ? this._zMin : undefined;
        var _zMax = this._zMax !== null ? this._zMax : undefined;
        var scale = this._scale;
        this._scale = scale.clampDomain(_xMin, _xMax, _zMin, _zMax);
        if (this._scale !== scale) {
            for (var i = 0; i < this._points.length; i += 1) {
                var scalePoint = this._points[i];
                scalePoint.domainCoord = this._scale.unscale(scalePoint.rangeCoord);
            }
        }
    };
    KinematicScale.prototype.rescale = function () {
        var p0 = this._points[0];
        var p1 = this._points[1];
        if (p0 && p1) {
            var x0 = p0.domainCoord;
            var y0 = p0.rangeCoord;
            var x1 = p1.domainCoord;
            var y1 = p1.rangeCoord;
            this._scale = this._scale.solveDomain(x0, y0, x1, y1);
            this.clampScale();
        }
        else if (p0) {
            var x0 = p0.domainCoord;
            var y0 = p0.rangeCoord;
            this._scale = this._scale.solveDomain(x0, y0);
            this.clampScale();
        }
    };
    KinematicScale.prototype.onKinematicStart = function (event) {
        this.scaleStart();
    };
    KinematicScale.prototype.onKinematicUpdate = function (event) {
        this.updatePoints(event.points);
        this.rescale();
        this.scaleUpdate();
    };
    KinematicScale.prototype.onKinematicEnd = function (event) {
        this.scaleEnd();
    };
    KinematicScale.prototype.scaleStart = function () {
        var event = new KinematicScaleEvent('kinematicscalestart', {
            bubbles: true,
            cancelable: true,
            composed: true,
            kinematicScale: this,
            kinematic: this._kinematic,
            ruler: this._ruler,
            scale: this._scale,
        });
        this._ruler.dispatchEvent(event);
    };
    KinematicScale.prototype.scaleUpdate = function () {
        var event = new KinematicScaleEvent('kinematicscaleupdate', {
            bubbles: true,
            cancelable: true,
            composed: true,
            kinematicScale: this,
            kinematic: this._kinematic,
            ruler: this._ruler,
            scale: this._scale,
        });
        this._ruler.dispatchEvent(event);
    };
    KinematicScale.prototype.scaleEnd = function () {
        var event = new KinematicScaleEvent('kinematicscaleend', {
            bubbles: true,
            cancelable: true,
            composed: true,
            kinematicScale: this,
            kinematic: this._kinematic,
            ruler: this._ruler,
            scale: this._scale,
        });
        this._ruler.dispatchEvent(event);
        this._points.length = 0;
    };
    KinematicScale.horizontal = function () {
        return new KinematicScaleHorizontal();
    };
    KinematicScale.vertical = function () {
        return new KinematicScaleVertical();
    };
    return KinematicScale;
}());
export { KinematicScale };
var KinematicScaleHorizontal = (function (_super) {
    tslib_1.__extends(KinematicScaleHorizontal, _super);
    function KinematicScaleHorizontal() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    KinematicScaleHorizontal.prototype.coords = function (clientX, clientY) {
        var bounds = this._ruler.getBoundingClientRect();
        return {
            domainCoord: this._scale.unscale(clientX - bounds.left),
            rangeCoord: clientX - bounds.left,
        };
    };
    KinematicScaleHorizontal.prototype.rangeCoord = function (clientX, clientY) {
        var bounds = this._ruler.getBoundingClientRect();
        return clientX - bounds.left;
    };
    KinematicScaleHorizontal.prototype.isParallel = function (x0, y0, x1, y1) {
        return Math.abs(x1 - x0) >= Math.abs(y1 - y0);
    };
    return KinematicScaleHorizontal;
}(KinematicScale));
export { KinematicScaleHorizontal };
var KinematicScaleVertical = (function (_super) {
    tslib_1.__extends(KinematicScaleVertical, _super);
    function KinematicScaleVertical() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    KinematicScaleVertical.prototype.coords = function (clientX, clientY) {
        var bounds = this._ruler.getBoundingClientRect();
        return {
            domainCoord: this._scale.unscale(clientY - bounds.top),
            rangeCoord: clientY - bounds.top,
        };
    };
    KinematicScaleVertical.prototype.rangeCoord = function (clientX, clientY) {
        var bounds = this._ruler.getBoundingClientRect();
        return clientY - bounds.top;
    };
    KinematicScaleVertical.prototype.isParallel = function (x0, y0, x1, y1) {
        return Math.abs(y1 - y0) >= Math.abs(x1 - x0);
    };
    return KinematicScaleVertical;
}(KinematicScale));
export { KinematicScaleVertical };
//# sourceMappingURL=data:application/json;base64,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